import { Fragment } from "react/jsx-runtime";
import { FormDataConsumer } from "react-admin";
import { GroupKey, JBoxTypeKey, RampTestKey } from "../types";
import { PlanningConfig } from "../constants/tableConfig";
import PlanningSectionHeader from "./PlanningSectionHeader";
import PlanningDataRows from "./PlanningDataRows";

interface PlanningSectionProps {
  config: PlanningConfig;
  rampTestKey: RampTestKey;
  existingJboxTypes: JBoxTypeKey[];
  idx: number;
}

const PlanningSection = ({ config, rampTestKey, existingJboxTypes, idx }: PlanningSectionProps) => {
  const { title, groupKey, fields } = config;
  const isSoc = groupKey === GroupKey.PlanningsSocManagement;

  return (
    <Fragment key={groupKey}>
      <FormDataConsumer>
        {({ formData }) => {
          const ramp = formData[rampTestKey];
          // SoC has its own toggle
          const socActive = isSoc ? ramp?.[groupKey]?.active : undefined;
          // Shared AFRR toggle lives at ramp level
          const afrrActive = ramp?.afrr_active ?? false;

          return (
            <>
              <PlanningSectionHeader
                title={title}
                groupKey={groupKey}
                rampTestKey={rampTestKey}
                existingJboxTypes={existingJboxTypes}
                isSoc={isSoc}
                idx={idx}
              />

              <PlanningDataRows
                fields={fields}
                groupKey={groupKey}
                rampTestKey={rampTestKey}
                existingJboxTypes={existingJboxTypes}
                isSoc={isSoc}
                socActive={socActive}
                afrrActive={afrrActive}
              />
            </>
          );
        }}
      </FormDataConsumer>
    </Fragment>
  );
};

export default PlanningSection;
